import { render } from "./RequestSupport.vue?vue&type=template&id=def8eb02&ts=true"
import script from "./RequestSupport.vue?vue&type=script&lang=ts"
export * from "./RequestSupport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__